import JsSdkBase from '../core/js-sdk-base';
import { FunctionKeys } from '../interface';
import { captureSdkResult, sdkLogger } from '../utils';

/**
 * 鉴权装饰器：用于jssdk API调用前需要config鉴权的场景
 * @param _ 类的实例
 * @param propKey 类的属性名
 * @param descriptor 类的属性描述符
 */
export function jsSdkAuth(
    _: JsSdkBase,
    propKey: FunctionKeys<JsSdkBase>,
    descriptor: PropertyDescriptor
) {
    const originalJsSdkApi = descriptor.value;
    type OriginalApiType = typeof originalJsSdkApi;
    descriptor.value = function (
        ...args: Parameters<OriginalApiType>
    ): ReturnType<OriginalApiType> {
        const sdkAuthLogExtra = {
            isSdkReady: this.isSdkReady,
            args
        };
        /**
         * 鉴权操作，如果鉴权失败，则直接调用基类中相应的默认方法
         */
        if (!this.isSdkReady) {
            sdkLogger.warn(
                `${this.sdkType} ${propKey} auth failed, try to fallback`,
                sdkAuthLogExtra
            );
            // 因为只给函数成员加该鉴权装饰器，所以 fallbackApi 一定是函数类型
            const fallbackApi = JsSdkBase.prototype[propKey];
            const result = fallbackApi.apply(this, args);
            return captureSdkResult({
                result,
                sdkType: this.sdkType,
                sdkApi: propKey,
                prefix: 'auth fallback'
            });
        }
        sdkLogger.info(`${this.sdkType} ${propKey} auth success`, sdkAuthLogExtra);
        return originalJsSdkApi.apply(this, args);
    };

    return descriptor;
}
